import { FunctionComponent } from 'react';

import { Badge as RadixBadge, BadgeProps } from '@radix-ui/themes';

export const Badge: FunctionComponent<BadgeProps> = (props: BadgeProps) => {
  return <RadixBadge {...props} />;
};
